import React, { useContext, useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";

import { makeStyles, withStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import SearchIcon from "@material-ui/icons/Search";
import { Add, ClearAllRounded, DoneAll, Facebook, Group, Instagram, OfflineBolt, WhatsApp } from "@material-ui/icons";
import InputBase from "@material-ui/core/InputBase";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Badge from "@material-ui/core/Badge";
import MoveToInboxIcon from "@material-ui/icons/MoveToInbox";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import MessageSharpIcon from "@material-ui/icons/MessageSharp";
import ClockIcon from "@material-ui/icons/AccessTime";
import GroupIcon from '@mui/icons-material/Group';


import FilterListIcon from '@material-ui/icons/FilterList';

import Switch from "@material-ui/core/Switch";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid"

import NewTicketModal from "../NewTicketModal";
import TicketsList from "../TicketsListCustom";
import TabPanel from "../TabPanel";

import { i18n } from "../../translate/i18n";
import { AuthContext } from "../../context/Auth/AuthContext";
import { Can } from "../Can";
import TicketsQueueSelect from "../TicketsQueueSelect";

import { TagsFilter } from "../TagsFilter";
import { UsersFilter } from "../UsersFilter";
import { StatusFilter } from "../StatusFilter";
import { WhatsappsFilter } from "../WhatsappsFilter";
import api from "../../services/api";
import { Box, Button, Chip, Snackbar, Tooltip } from "@material-ui/core";
import { IconButton, SpeedDial, SpeedDialAction, Stack } from "@mui/material";
import { QueueSelectedContext } from "../../context/QueuesSelected/QueuesSelectedContext";

import AddIcon from '@mui/icons-material/Add';

const GreenSwitch = withStyles({
  switchBase: {
    color: "#ccc",
    "&$checked": { color: "#35af9a" },
    "&$checked + $track": { backgroundColor: "#35af9a" },
  },
  checked: {},
  track: {},
})(Switch);

const useStyles = makeStyles((theme) => ({
  ticketsWrapper: {
    position: "relative",
    display: "flex",
    height: "100%",
    flexDirection: "column",
    overflow: "hidden",
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
  },

  tabsHeader: {
    flex: "none",
    backgroundColor: theme.palette.background.paper,
    borderBottom: theme.palette.type === "dark"
      ? "1px solid rgba(255,255,255,0.06)"
      : "1px solid #E2E8F0",
  },

  settingsIcon: {
    alignSelf: "center",
    marginLeft: "auto",
    padding: 8,
  },

  tab: {
    minWidth: 120,
    width: 120,
  },

  snackbar: {
    backgroundColor: theme.palette.primary.main,
    color: 'white',
    borderRadius: 12,
    fontFamily: '"Inter", "Poppins", sans-serif',
    fontSize: 14,
  },

  yesButton: {
    backgroundColor: '#FFF',
    color: 'rgba(0, 100, 0, 1)',
    padding: '6px 16px',
    fontSize: '0.85em',
    fontWeight: 600,
    textTransform: 'none',
    marginRight: theme.spacing(1),
    fontFamily: '"Inter", "Poppins", sans-serif',
    '&:hover': {
      backgroundColor: 'darkGreen',
      color: '#FFF',
    },
    borderRadius: 8,
  },
  noButton: {
    backgroundColor: '#FFF',
    color: 'rgba(139, 0, 0, 1)',
    padding: '6px 16px',
    fontSize: '0.85em',
    fontWeight: 600,
    textTransform: 'none',
    fontFamily: '"Inter", "Poppins", sans-serif',
    '&:hover': {
      backgroundColor: 'darkRed',
      color: '#FFF',
    },
    borderRadius: 8,
  },

  tabPanelItem: {
    minWidth: 100,
    fontSize: 11,
    marginLeft: 0,
    fontFamily: '"Inter", "Poppins", sans-serif',
    textTransform: "none",
    fontWeight: 600,
  },

  ticketOptionsBox: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    background: theme.palette.background.paper,
  },

  serachInputWrapper: {
    flex: 1,
    background: theme.palette.type === "dark" ? "rgba(255,255,255,0.04)" : "#F8FAFC",
    display: "flex",
    borderRadius: 12,
    padding: "2px 4px",
    marginRight: theme.spacing(1),
    border: theme.palette.type === "dark"
      ? "1px solid rgba(255,255,255,0.08)"
      : "1px solid #E2E8F0",
    transition: "border-color 0.15s ease, box-shadow 0.15s ease",
    "&:focus-within": {
      borderColor: "#35af9a",
      boxShadow: "0 0 0 3px rgba(53, 175, 154, 0.1)",
    },
  },

  searchIcon: {
    color: theme.palette.type === "dark" ? "#94A3B8" : "#94A3B8",
    marginLeft: 8,
    marginRight: 4,
    alignSelf: "center",
    fontSize: 20,
  },

  searchInput: {
    flex: 1,
    border: "none",
    borderRadius: 12,
    fontFamily: '"Inter", "Poppins", sans-serif',
    fontSize: 14,
  },

  badge: {
    // right: "-10px",
  },

  show: {
    display: "block",
  },

  hide: {
    display: "none !important",
  },

  speedDial: {
    position: 'absolute',
    bottom: theme.spacing(1),
    right: theme.spacing(1),
  },

  headerTitle: {
    fontWeight: 700,
    fontFamily: '"Inter", "Poppins", sans-serif',
    color: theme.palette.type === "dark" ? "#F1F5F9" : "#1E293B",
    fontSize: "1.1rem",
    letterSpacing: "-0.01em",
  },

  tabIconButton: {
    width: 36,
    height: 36,
    borderRadius: 10,
    transition: "all 0.15s ease",
  },

  tabIconActive: {
    backgroundColor: "#35af9a !important",
    color: "#fff !important",
    boxShadow: "0 2px 8px rgba(53, 175, 154, 0.3)",
  },

  tabIconInactive: {
    backgroundColor: theme.palette.type === "dark"
      ? "rgba(255,255,255,0.06) !important"
      : "#F1F5F9 !important",
    color: theme.palette.type === "dark"
      ? "#94A3B8 !important"
      : "#64748B !important",
    "&:hover": {
      backgroundColor: theme.palette.type === "dark"
        ? "rgba(255,255,255,0.1) !important"
        : "#E2E8F0 !important",
    },
  },

  filterButton: {
    borderRadius: 10,
    color: theme.palette.type === "dark" ? "#94A3B8" : "#64748B",
    "&:hover": {
      backgroundColor: theme.palette.type === "dark"
        ? "rgba(255,255,255,0.06)"
        : "#F1F5F9",
    },
  },
  tagChip: {
    fontFamily: '"Inter", "Poppins", sans-serif',
    fontWeight: 600,
    fontSize: 13,
  },
  tagChipActive: {
    backgroundColor: "#35af9a !important",
    color: "#fff !important",
    "&:hover": {
      backgroundColor: "#2d9a87 !important",
    },
    "&:focus": {
      backgroundColor: "#35af9a !important",
      color: "#fff !important",
    },
    "&.Mui-focusVisible": {
      backgroundColor: "#35af9a !important",
      color: "#fff !important",
    },
  },
  tagChipInactive: {
    backgroundColor: "transparent",
    border: `1px solid ${theme.palette.type === "dark" ? "rgba(255,255,255,0.2)" : "#E2E8F0"}`,
    color: theme.palette.type === "dark" ? "#94A3B8" : "#64748B",
    "&:hover": {
      backgroundColor: theme.palette.type === "dark" ? "rgba(255,255,255,0.06)" : "#F8FAFC",
    },
  },
  showAllSwitchContainer: {
    display: "flex",
    alignItems: "center",
    gap: 2,
    padding: "2px 6px",
    borderRadius: 8,
    backgroundColor: theme.palette.type === "dark" ? "rgba(255,255,255,0.04)" : "#F8FAFC",
    border: `1px solid ${theme.palette.type === "dark" ? "rgba(255,255,255,0.08)" : "#E2E8F0"}`,
  },
  showAllLabel: {
    fontFamily: '"Inter", "Poppins", sans-serif',
    fontSize: "0.7rem",
    fontWeight: 500,
    color: theme.palette.type === "dark" ? "#94A3B8" : "#64748B",
    whiteSpace: "nowrap",
  },

  innerTabs: {
    "& .MuiTabs-indicator": {
      backgroundColor: "#35af9a",
      height: 3,
      borderRadius: "3px 3px 0 0",
    },
    "& .MuiTab-root": {
      fontFamily: '"Inter", "Poppins", sans-serif',
      textTransform: "none",
      fontWeight: 600,
      fontSize: 12,
    },
  },

  openTabLayout: {
    display: "flex",
    flexDirection: "row",
    height: "100%",
    minHeight: 0,
    flex: 1,
  },

  openTabStrip: {
    width: 52,
    flexShrink: 0,
    alignSelf: "stretch",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    paddingTop: 8,
    gap: 4,
    borderRight: theme.palette.type === "dark"
      ? "1px solid rgba(255,255,255,0.06)"
      : "1px solid #E2E8F0",
    backgroundColor: theme.palette.type === "dark"
      ? "rgba(255,255,255,0.02)"
      : "#F8FAFC",
  },

  openTabStripItem: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: 2,
    width: 44,
    height: 44,
    borderRadius: 10,
    cursor: "pointer",
    transition: "all 0.15s ease",
    border: "none",
    outline: "none",
    backgroundColor: "transparent",
    color: theme.palette.type === "dark" ? "#94A3B8" : "#64748B",
    "&:hover": {
      backgroundColor: theme.palette.type === "dark"
        ? "rgba(255,255,255,0.06)"
        : "#E2E8F0",
    },
  },

  openTabStripItemActive: {
    color: "#35af9a !important",
    backgroundColor: theme.palette.type === "dark"
      ? "rgba(53, 175, 154, 0.12) !important"
      : "rgba(53, 175, 154, 0.08) !important",
  },

  openTabStripLabel: {
    fontFamily: '"Inter", "Poppins", sans-serif',
    fontSize: 9,
    fontWeight: 600,
    lineHeight: 1,
    textAlign: "center",
    whiteSpace: "nowrap",
  },

  openTabListArea: {
    flex: 1,
    minWidth: 0,
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    position: "relative",
    height: "100%",
  },
}));

const TicketsManagerTabs = () => {
  const classes = useStyles();
  const history = useHistory();

  const [searchParam, setSearchParam] = useState("");
  const [tab, setTab] = useState("open");
  const [tabOpen, setTabOpen] = useState("open");
  const [newTicketModalOpen, setNewTicketModalOpen] = useState(false);
  const [showAllTickets, setShowAllTickets] = useState(false);
  const searchInputRef = useRef();
  const { user } = useContext(AuthContext);
  const { profile } = user;

  const [openCount, setOpenCount] = useState(0);
  const [pendingCount, setPendingCount] = useState(0);
  const [groupingCount, setGroupingCount] = useState(0);

  const userQueueIds = user.queues.map((q) => q.id);
  const [selectedQueueIds, setSelectedQueueIds] = useState(userQueueIds || []);
  const [selectedTags, setSelectedTags] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectedWhatsapp, setSelectedWhatsapp] = useState([]);
  // const [forceSearch, setForceSearch] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState([]);
  const [filter, setFilter] = useState(false);
  // const [open, setOpen] = useState(false);
  // const [hidden, setHidden] = useState(false);

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const { setSelectedQueuesMessage } = useContext(QueueSelectedContext);

  useEffect(() => {
    if (user.profile.toUpperCase() === "ADMIN") {
      setShowAllTickets(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setSelectedQueuesMessage(selectedQueueIds);
  }, []);
  // }, [selectedQueueIds]);

  useEffect(() => {
    if (tab === "search") {
      searchInputRef.current.focus();
    }
    // setForceSearch(!forceSearch)
  }, []);


  let searchTimeout;

  const handleSearch = e => {
    const searchedTerm = e.target.value.toLowerCase()?.trim();

    clearTimeout(searchTimeout);

    if (searchedTerm === "") {
      setSearchParam(searchedTerm);
      setTab("open");
      return;
    }

    if (searchedTerm.length > 1) {
      setTab("search");
    }

    searchTimeout = setTimeout(() => {
      setSearchParam(searchedTerm);
    }, 500);
  };

  // const handleBack = React.useCallback(() => {
  //   history.push("/tickets");
  // },[history]);

  const handleSnackbarOpen = React.useCallback(() => {
    setSnackbarOpen(true);
  }, []);

  const handleSnackbarClose = React.useCallback(() => {
    setSnackbarOpen(false);
  }, []);

  const handleChangeTab = (e, newValue) => {
    setTab(newValue);
  };

  const handleChangeTabOpen = (e, newValue) => {
    setTabOpen(newValue);
  };

  const applyPanelStyle = status => {
    if (tabOpen !== status) {
      return { width: 0, height: 0 };
    }
  };

  const CloseAllTicket = async () => {
    try {
      const { data } = await api.post("/tickets/closeAll", { status: tabOpen, queueIds: selectedQueueIds });
      handleSnackbarClose();
    } catch (err) {
      console.log("Error: ", err);
    }
  };


  // const handleVisibility = () => {
  //   setHidden((prevHidden) => !prevHidden);
  // };

  // const handleOpen = () => {
  //   setOpen(true);
  // };

  // const handleClosed = () => {
  //   setOpen(false);
  // };

  const tooltipTitleStyle = {
    fontSize: '10px'
  };

  const handleCloseOrOpenTicket = ticket => {
    setNewTicketModalOpen(false);
    if (ticket !== undefined && ticket.uuid !== undefined) {
      history.push(`/tickets/${ticket.uuid}`);
    }
  };

  const handleSelectedTags = selecteds => {
    const tags = selecteds.map(t => t.id);
    setSelectedTags(tags);
  };

  const handleSelectedUsers = (selecteds) => {
    const users = selecteds.map(t => t.id);
    setSelectedUsers(users);
  };

  const handleSelectedWhatsapps = (selecteds) => {
    const whatsapp = selecteds.map((t) => t.id);
    setSelectedWhatsapp(whatsapp);
  };

  const handleSelectedStatus = (selecteds) => {
    const statusFilter = selecteds.map((t) => t.status);

    setSelectedStatus(statusFilter);
  };

  const handleFilter = () => {
    if (filter) {
      setFilter(false);
      setTab("open")
    }
    else
      setFilter(true);
    setTab("search")
  };

  return (
    <Paper
      elevation={0}
      variant="outlined"
      className={classes.ticketsWrapper}
    >
      <Snackbar
        open={snackbarOpen}
        onClose={handleSnackbarClose}
        message={i18n.t("ticketsManager.questionCloseTicket")}
        ContentProps={{
          className: classes.snackbar,
        }}
        action={
          <>
            <Button className={classes.yesButton} size="small" onClick={CloseAllTicket}>
              {i18n.t("ticketsManager.yes")}
            </Button>
            <Button className={classes.noButton} size="small" onClick={handleSnackbarClose}>
              {i18n.t("ticketsManager.not")}
            </Button>
          </>
        }
      />

      <NewTicketModal
        modalOpen={newTicketModalOpen}
        onClose={(ticket) => {
          handleCloseOrOpenTicket(ticket);
        }}
      />



      {filter === true && (
        <>

          <TagsFilter onFiltered={handleSelectedTags} />
          <WhatsappsFilter onFiltered={handleSelectedWhatsapps} />
          <StatusFilter onFiltered={handleSelectedStatus} />
          {profile === "admin" && (
            <>
              <UsersFilter onFiltered={handleSelectedUsers} />
            </>
          )}
        </>
      )}


      <Paper elevation={0} square className={classes.tabsHeader}>

        <Stack direction="row" spacing={1.5} sx={{ display: 'flex', alignItems: 'center', px: 2, py: 2, justifyContent: 'space-between' }}>

          <Typography className={classes.headerTitle}>Conversas</Typography>

          <Stack direction={'row'} sx={{ alignItems: 'center' }} spacing={0.75} >

            <IconButton
              onClick={(e) => setNewTicketModalOpen(true)}
              className={`${classes.tabIconButton} ${classes.tabIconInactive}`}
              size="small"
              aria-label="novo ticket"
            >
              <AddIcon style={{ fontSize: 20 }} />
            </IconButton>

            <Box>
              <Can
                role={user.profile}
                perform="tickets-manager:showall"
                yes={() => (
                  <div className={classes.showAllSwitchContainer}>
                    <Typography className={classes.showAllLabel}>
                      {i18n.t("tickets.buttons.showAllTickets")}
                    </Typography>
                    <GreenSwitch
                      size="small"
                      checked={showAllTickets}
                      onChange={() =>
                        setShowAllTickets((prevState) => !prevState)
                      }
                      name="showAllTickets"
                    />
                  </div>
                )}
              />
              <SpeedDial
                ariaLabel="Menu Actions"
                className={classes.speedDial}
                size="small"
                icon={<OfflineBolt />}
              >
                {user.profile === 'admin' && (
                  <SpeedDialAction
                    icon={<DoneAll style={{ color: '#16A34A' }} />}
                    className={classes.closeAllFab}
                    tooltipTitle={<span style={tooltipTitleStyle}>{i18n.t("ticketsManager.buttons.close")}&nbsp;Todos</span>}
                    tooltipOpen
                    onClick={(event) => {
                      handleSnackbarOpen();
                    }}
                  />
                )}

                <SpeedDialAction
                  icon={<Add style={{ color: '#35af9a' }} />}
                  tooltipTitle={<span style={tooltipTitleStyle}>{i18n.t("ticketsManager.buttons.new")}&nbsp;Ticket</span>}
                  tooltipOpen
                  onClick={() => {
                    setNewTicketModalOpen(true);
                  }}
                />
              </SpeedDial>
            </Box>

          </Stack>

        </Stack>

        <Stack direction={'row'} sx={{ alignItems: 'center' }} spacing={1} px={2} pb={1.5} >
          <div className={classes.serachInputWrapper}>

            <SearchIcon className={classes.searchIcon} />
            <InputBase
              className={classes.searchInput}
              inputRef={searchInputRef}
              placeholder={i18n.t("tickets.search.placeholder")}
              type="search"
              onChange={handleSearch}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  setTab("search");
                  e.target.blur();
                }
              }}
            />
            <IconButton
              className={classes.filterButton}
              size="small"
              onClick={handleFilter}
            >
              <FilterListIcon style={{ fontSize: 20 }} />
            </IconButton>
          </div>

          <TicketsQueueSelect
            style={{ marginLeft: 6 }}
            selectedQueueIds={selectedQueueIds}
            userQueues={user?.queues}
            onChange={(values) => {
              setSelectedQueueIds(values);
            }}
          />
        </Stack>

        <Stack direction="row" sx={{ alignItems: "center", gap: 1 }} px={2} pb={1.5}>
          <Chip
            label={i18n.t("tickets.tabs.open.title")}
            onClick={() => handleChangeTab(null, "open")}
            className={`${classes.tagChip} ${tab === "open" ? classes.tagChipActive : classes.tagChipInactive}`}
            size="small"
          />
          <Chip
            label={i18n.t("tickets.tabs.closed.title")}
            onClick={() => handleChangeTab(null, "closed")}
            className={`${classes.tagChip} ${tab === "closed" ? classes.tagChipActive : classes.tagChipInactive}`}
            size="small"
          />
        </Stack>


        {/* <Tabs
          value={tab}
          onChange={handleChangeTab}
          variant="fullWidth"
          indicatorColor="primary"
          textColor="primary"
          aria-label="icon label tabs example"
        >

          <Tab
            value={"open"}
            icon={<MoveToInboxIcon />}
            label={i18n.t("tickets.tabs.open.title")}
            classes={{ root: classes.tab }}
          />

          <Tab
            value={"closed"}
            icon={<CheckBoxIcon />}
            label={i18n.t("tickets.tabs.closed.title")}
            classes={{ root: classes.tab }}
          />

          <Tab
            value={"search"}
            icon={<SearchIcon />}
            label={i18n.t("tickets.tabs.search.title")}
            classes={{ root: classes.tab }}
          />
        </Tabs> */}
      </Paper>



      <Paper square elevation={0} className={classes.ticketOptionsBox}>
        <>
          {/* <Can
            role={user.profile}
            perform="tickets-manager:showall"
            yes={() => (
              <FormControlLabel
                label={i18n.t("tickets.buttons.showAll")}
                labelPlacement="start"
                control={
                  <Switch
                    size="small"
                    checked={showAllTickets}
                    onChange={() =>
                      setShowAllTickets((prevState) => !prevState)
                    }
                    name="showAllTickets"
                    color="primary"
                  />
                }
              />
            )}
          /> */}
          {/* <SpeedDial
            ariaLabel="Menu Actions"
            className={classes.speedDial}
            // hidden={hidden}
            size="small"
            icon={<OfflineBolt />}

          >
            {user.profile === 'admin' && (
              <SpeedDialAction
                icon={<DoneAll style={{ color: 'green' }} />}
                className={classes.closeAllFab}
                tooltipTitle={<span style={tooltipTitleStyle}>{i18n.t("ticketsManager.buttons.close")}&nbsp;Todos</span>}
                tooltipOpen
                onClick={(event) => {
                  // handleClosed();
                  handleSnackbarOpen();
                }}
              />
            )}

            <SpeedDialAction
              icon={<Add style={{ color: '#25D366' }} />}
              tooltipTitle={<span style={tooltipTitleStyle}>{i18n.t("ticketsManager.buttons.new")}&nbsp;Ticket</span>}
              tooltipOpen
              onClick={() => {
                // handleClosed();
                setNewTicketModalOpen(true);
              }}
            />
          </SpeedDial> */}
        </>
        {/* <TicketsQueueSelect
          style={{ marginLeft: 6 }}
          selectedQueueIds={selectedQueueIds}
          userQueues={user?.queues}
          onChange={(values) => {
            setSelectedQueueIds(values);
            //history.push("/tickets");
          }}
        /> */}
      </Paper>

      <TabPanel
        value={tab}
        name="open"
        className={classes.ticketsWrapper}
      >
        <div className={classes.openTabLayout}>
          <div className={classes.openTabStrip}>
            <Tooltip title={i18n.t("ticketsList.assignedHeader")} placement="right" arrow>
              <button
                className={`${classes.openTabStripItem} ${tabOpen === "open" ? classes.openTabStripItemActive : ""}`}
                onClick={() => handleChangeTabOpen(null, "open")}
                aria-selected={tabOpen === "open"}
              >
                <Badge overlap="rectangular" className={classes.badge} badgeContent={openCount} color="primary">
                  <MessageSharpIcon style={{ fontSize: 20 }} />
                </Badge>
              </button>
            </Tooltip>
            <Tooltip title={i18n.t("ticketsList.pendingHeader")} placement="right" arrow>
              <button
                className={`${classes.openTabStripItem} ${tabOpen === "pending" ? classes.openTabStripItemActive : ""}`}
                onClick={() => handleChangeTabOpen(null, "pending")}
                aria-selected={tabOpen === "pending"}
              >
                <Badge overlap="rectangular" className={classes.badge} badgeContent={pendingCount} color="primary">
                  <ClockIcon style={{ fontSize: 20 }} />
                </Badge>
              </button>
            </Tooltip>
            <Tooltip title={i18n.t("ticketsList.groupingHeader")} placement="right" arrow>
              <button
                className={`${classes.openTabStripItem} ${tabOpen === "group" ? classes.openTabStripItemActive : ""}`}
                onClick={() => handleChangeTabOpen(null, "group")}
                aria-selected={tabOpen === "group"}
              >
                <Badge overlap="rectangular" className={classes.badge} badgeContent={groupingCount} color="primary">
                  <Group style={{ fontSize: 20 }} />
                </Badge>
              </button>
            </Tooltip>
          </div>
          <Paper className={classes.openTabListArea}>
            <TicketsList
              status="open"
              showAll={showAllTickets}
              selectedQueueIds={selectedQueueIds}
              updateCount={(val) => setOpenCount(val)}
              style={applyPanelStyle("open")}
              forceSearch={false}
              user={user}
            />
            <TicketsList
              status="pending"
              selectedQueueIds={selectedQueueIds}
              showAll={user.profile === "admin" ? showAllTickets : false}
              updateCount={(val) => setPendingCount(val)}
              style={applyPanelStyle("pending")}
              forceSearch={false}
              user={user}
            />
            <TicketsList
              status="group"
              showAll={showAllTickets}
              selectedQueueIds={selectedQueueIds}
              updateCount={(val) => setGroupingCount(val)}
              style={applyPanelStyle("group")}
              forceSearch={false}
              user={user}
            />
          </Paper>
        </div>
      </TabPanel>

      <TabPanel value={tab} name="closed" className={classes.ticketsWrapper}>
        <TicketsList
          status="closed"
          showAll={showAllTickets}
          selectedQueueIds={selectedQueueIds}
          user={user}
        // handleChangeTab={handleChangeTabOpen}
        />
      </TabPanel>

      <TabPanel value={tab} name="search" className={classes.ticketsWrapper}>
        {profile === "admin" && (
          <>
            <TicketsList
              statusFilter={selectedStatus}
              searchParam={searchParam}
              showAll={showAllTickets}
              tags={selectedTags}
              users={selectedUsers}
              selectedQueueIds={selectedQueueIds}
              whatsappIds={selectedWhatsapp}
              forceSearch={true}
              status="search"
              user={user}
            />
          </>
        )}

        {profile === "user" && (
          <TicketsList
            statusFilter={selectedStatus}
            searchParam={searchParam}
            showAll={false}
            tags={selectedTags}
            selectedQueueIds={selectedQueueIds}
            whatsappIds={selectedWhatsapp}
            forceSearch={true}
            status="search"
            user={user}
          />
        )}
      </TabPanel>
    </Paper>
  );
};

export default React.memo(TicketsManagerTabs);
